/* 🤖 this file was generated by svg-to-ts*/
export const icoBookmarkDeleteFilled: {
  name: 'bookmark-delete-filled';
  data: string;
} = {
  name: 'bookmark-delete-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 2a2 2 0 011.994 1.85L19 4v17a1 1 0 01-1.55.836l-.09-.068L12 17.302l-5.36 4.466c-.59.492-1.459.157-1.615-.541l-.019-.114L5 21V4a2 2 0 011.85-1.995L7 2h10zm-6.387 5.21a1 1 0 00-1.32 1.497L10.585 10l-1.292 1.293-.083.094a1 1 0 001.403 1.403l.094-.083L12 11.415l1.293 1.292.094.083a1 1 0 001.32-1.497L13.415 10l1.292-1.293.083-.094a1 1 0 00-1.403-1.403l-.094.083L12 8.585l-1.293-1.292-.094-.083z" fill="#909090"/></svg>`
};
